const Gifts = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="91"
      height="90"
      viewBox="0 0 91 90"
      fill="none"
      {...props}
    >
      <path
        d="M40.0107 27.2949L40.0107 75.4783"
        stroke="#C89050"
        stroke-width="3.96027"
      />
      <path
        d="M51.2324 27.2949L51.2324 75.4783"
        stroke="#C89050"
        stroke-width="3.96027"
      />
      <path
        d="M46.9782 17.2056C46.9782 12.7572 50.5843 9.15103 55.0327 9.15103H56.1821C60.6181 9.15103 64.2141 12.7471 64.2141 17.183C64.2141 21.619 60.6181 25.215 56.1821 25.215H46.9782V17.2056Z"
        stroke="#C89050"
        stroke-width="3.96027"
      />
      <path
        d="M43.0179 17.2056C43.0179 12.7572 39.4118 9.15103 34.9634 9.15103H33.814C29.378 9.15103 25.782 12.7471 25.782 17.183C25.782 21.619 29.378 25.215 33.814 25.215H43.0179V17.2056Z"
        stroke="#C89050"
        stroke-width="3.96027"
      />
      <path
        d="M72.0026 77.2803C73.2525 77.2803 74.2656 76.2671 74.2656 75.0173V41.1595C74.2656 39.9097 73.2525 38.8965 72.0026 38.8965H19.1683C17.9185 38.8965 16.9053 39.9097 16.9053 41.1595V75.0173C16.9053 76.2671 17.9185 77.2803 19.1683 77.2803H72.0026Z"
        stroke="#333333"
        stroke-width="3.96027"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M77.7374 25.4619H13.431C12.1812 25.4619 11.168 26.4751 11.168 27.7249V36.6332C11.168 37.8831 12.1811 38.8962 13.431 38.8962H77.7374C78.9872 38.8962 80.0004 37.8831 80.0004 36.6332V27.7249C80.0004 26.4751 78.9872 25.4619 77.7374 25.4619Z"
        stroke="#333333"
        stroke-width="3.96027"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default Gifts
